
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAdminContext } from '@/context/AdminContext';
import AdminPageLoader from '@/components/admin/AdminPageLoader';

interface AdminProtectedRouteProps {
  children?: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAdmin, isLoading } = useAdminContext();

  if (isLoading) {
    return <AdminPageLoader />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default AdminProtectedRoute;
